import { render, staticRenderFns } from "./Quick-Step-3.vue?vue&type=template&id=ef255ef0&scoped=true&"
import script from "./Quick-Step-3.vue?vue&type=script&lang=js&"
export * from "./Quick-Step-3.vue?vue&type=script&lang=js&"
import style0 from "./Quick-Step-3.vue?vue&type=style&index=0&id=ef255ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef255ef0",
  null
  
)

export default component.exports